// Which login the stored token came from. The super-admin panel and the
// trusted-roles portal (RO1, RO2, Security Officer, Operator, Auditor) share
// the token storage and refresh logic, but each only accepts its own token.
const PORTAL_STORAGE_KEY = "authPortal";

export const PORTAL_ADMIN = "admin";
export const PORTAL_TRUSTED = "trusted";

export const getAuthPortal = () =>
  localStorage.getItem(PORTAL_STORAGE_KEY) === PORTAL_TRUSTED
    ? PORTAL_TRUSTED
    : PORTAL_ADMIN;

export const setAuthPortal = (portal) => {
  localStorage.setItem(PORTAL_STORAGE_KEY, portal);
};

export const clearAuthPortal = () => {
  localStorage.removeItem(PORTAL_STORAGE_KEY);
};

export const getLoginPath = (portal = getAuthPortal()) =>
  portal === PORTAL_TRUSTED ? "/trusted/login" : "/login";

export const getHomePath = (portal = getAuthPortal()) =>
  portal === PORTAL_TRUSTED ? "/trusted" : "/reports";
